// Client-Side Form Validation - Part 2 - Error Reporting
//
// Based on:
// https://developer.mozilla.org/en-US/docs/Learn/Forms/Form_validation
// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html

function showError(field, field_error, error_type, formName, fieldName) {
    var validityState;
    if (field.validity.valueMissing) {
        if (field.type == 'checkbox') {
            if (field.id.startsWith('osobni')) {
                field_error.textContent = 'Consent is required for form submission.';
            } else {
                field_error.innerHTML = '<br>Please choose one or more options.';
            }
        } else if (field.type == 'radio') {
            field_error.innerHTML = '<br>Please choose one from the options.';
        } else {
            field_error.textContent = 'Please fill in this field.';
        }
        validityState = "valueMissing";
    } else if (field.validity.typeMismatch) {
        if (field.type == 'email') {
            field_error.textContent = 'Please check inserted email address.';
        } else {
            field_error.textContent = 'Please check inserted data.';
        }
        validityState = "typeMismatch";
    } else if (field.validity.patternMismatch) { // ^(\+|00)[1-9][0-9 \-\(\)\.]{6,14}$
        if (field.type == 'tel') {
            field_error.textContent = 'International phone number format is required.';
        } else {
            field_error.textContent = 'Please check inserted data.';
        }
        validityState = "patternMismatch";
    } else if (field.validity.tooShort) {
        let suffix = '';
        if (field.minLength > 1) {
            suffix = 's';
        }
        field_error.textContent = 'Please enter ' + field.minLength + ' character' + suffix + ' at least.';
        validityState = "tooShort";
    } else if (field.validity.badInput) {
        field_error.textContent = 'Please check inserted data format.';
        validityState = "badInput";
    } else if (field.validity.stepMismatch) {
        field_error.textContent = 'The value does not match the unit size.';
        validityState = "stepMismatch";
    } else if (field.validity.rangeOverflow) {
        field_error.textContent = 'The value is higher than possible.';
        validityState = "rangeOverflow";
    } else if (field.validity.rangeUnderflow) {
        field_error.textContent = 'The value is lower than possible.';
        validityState = "rangeUnderflow";
    }

    if (error_type == 'passwordConfirmFails') {
        field_error.textContent = 'The value does not match the entered password.';
        validityState = "passwordConfirmFails";
    }

    if (error_type == 'amountChangeNotSent') {
        field_error.textContent = 'Confirm change with the button.';
        validityState = "amountChangeNotSent";
    }

    if (error_type == 'invalidIc') {
        field_error.textContent = 'The ID No. value is invalid.';
        validityState = "invalidIc";
    }

    if (error_type == 'icNotFound') {
        field_error.textContent = 'The ID No. value not found in the register.';
        validityState = "icNotFound";
    }

    if (error_type == 'aresUnavailable') {
        field_error.textContent = 'The automatic data retrieval service is down.';
        validityState = "aresUnavailable";
    }

    field_error.className = 'field-error active';

    window.dataLayer.push({
        'event' : 'formError',
        'formName' : formName,
        'fieldName' : fieldName + ' [' + validityState  + ']'
    });
}